"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SampleEventFactoryInterface = _interopRequireDefault(require("crm_ui/utils/sampleData/SampleEventFactoryInterface"));

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _TimelineConstants = require("crm_universal/timeline/TimelineConstants");

var _UserStore = _interopRequireDefault(require("crm_data/user/UserStore"));

var USER = _UserStore.default.get();

var makeEmailLogSampleTimelineEvent = (0, _SampleEventFactoryInterface.default)({
  requiredData: {
    eventType: _TimelineConstants.EVENT_ENGAGEMENT,
    itemType: _EngagementTypes.EMAIL
  },
  eventDefaults: {
    subject: '',
    html: '',
    text: '',
    fromEmail: USER.email,
    fromFirstName: USER.first_name,
    fromLastName: USER.last_name
  },
  build: function build(emailData) {
    var subject = emailData.subject,
        html = emailData.html,
        text = emailData.text,
        fromEmail = emailData.fromEmail,
        fromFirstName = emailData.fromFirstName,
        fromLastName = emailData.fromLastName,
        toEmail = emailData.toEmail,
        toFirstName = emailData.toFirstName,
        toLastName = emailData.toLastName;
    var eventData = {
      metadata: {
        html: html,
        text: text,
        subject: subject,
        bcc: [],
        cc: [],
        from: {
          email: fromEmail,
          firstName: fromFirstName,
          lastName: fromLastName
        },
        to: [{
          email: toEmail,
          firstName: toFirstName,
          lastName: toLastName
        }]
      }
    };
    return eventData;
  }
});
var _default = makeEmailLogSampleTimelineEvent;
exports.default = _default;
module.exports = exports.default;